
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path opacity="0.3" d="M22 17C22 14.3478 20.9464 11.8043 19.0711 9.92893C18.7345 9.59237 18.3764 9.28228 18.0001 9"></path><path d="M2 17C2 14.3478 3.05357 11.8043 4.92893 9.92893C6.8043 8.05357 9.34784 7 12 7C14.1762 7 16.2793 7.70935 18.0001 9"></path><path d="M12 17.0001L15.468 12.3065"></path><path d="M3.49998 16.5031H4.49998"></path><path d="M19.5 16.5343H20.5"></path><path d="M5.78998 11L6.49708 11.7071"></path><path d="M17.6465 11.7072L18.3536 11"></path><path d="M12 9.5V8.5"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiGauge",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
